// Creating a single import/export for breakpoints in isolation for TED UI
import { tuiBreakpoints } from '../../../../design-tokens/constants';

const UI_DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};

export { tuiBreakpoints, UI_DIRECTIONS };
